import { React, PT, WithData } from '@gasbuddy/react';
import moment from 'moment';
import { Dimmer, Loader, Table, Segment } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';

function diffScore(d) {
  if (!d.hash) {
    return 0;
  }
  if (d.hash === d.master) {
    return 1;
  }
  return 2;
}

function diffLink(d) {
  if (!d.hash) {
    return '-';
  }
  if (d.hash === d.master) {
    return (
      <span style={{ color: 'green' }} aria-label="check" role="img">&#10004;</span>
    );
  }
  return (
    <a href={`https://github.com/gas-buddy/${d.name}/compare/${d.hash}...master`} rel="noopener noreferrer" target="_blank">view on github</a>
  );
}

class BaseDeployments extends React.Component {
  state = {
    column: 'name',
    direction: 'ascending',
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  render() {
    const { column, direction } = this.state;
    const { data, loading } = this.props;

    const dir = direction === 'ascending' ? 1 : -1;
    const deployments = data ? data.deployments.slice().sort((a, b) => {
      switch (column) {
        case 'name':
          return (a.name.localeCompare(b.name)) * dir;
        case 'replicas':
          return ((a.number - b.number) * dir)
            || (a.name.localeCompare(b.name));
        case 'deployed':
          return dir * (moment(a.updated).valueOf() - moment(b.updated).valueOf());
        case 'diff':
          return (dir * (diffScore(a) - diffScore(b)))
            || (a.name.localeCompare(b.name));
        default:
          return 0;
      }
    }) : [];


    return (
      <Auth forRoles="admin.superuser,admin.system">
        <Nav>
          <div>
            <h1>Deployments</h1>
            <Dimmer.Dimmable as={Segment} dimmed={loading}>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
              <Table sortable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell sorted={column === 'name' && direction} onClick={this.handleSort('name')}>Service</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'deployed' && direction} onClick={this.handleSort('deployed')}>Deployed</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'replicas' && direction} onClick={this.handleSort('replicas')}>Replicas</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'diff' && direction} onClick={this.handleSort('diff')}>Diff to Master</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {deployments.map(d => (
                    <Table.Row key={d.name}>
                      <Table.Cell>{d.name}</Table.Cell>
                      <Table.Cell textAlign="center">
                        <a
                          href={`https://github.com/gas-buddy/${d.name}/commit/${d.hash}`}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {moment.duration(moment(d.updated).diff(moment())).humanize()}
                        </a>
                      </Table.Cell>
                      <Table.Cell textAlign="center">{d.replicas}</Table.Cell>
                      <Table.Cell textAlign="center">{diffLink(d)}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseDeployments.propTypes = {
  data: PT.shape({
    deployments: PT.arrayOf(PT.shape({
      replicas: PT.number,
      name: PT.string,
      hash: PT.string,
    })),
  }),
  loading: PT.bool,
};

BaseDeployments.defaultProps = { loading: false, data: null };

export const Deployments = () => (
  <WithData url="/system/deployments">
    <BaseDeployments />
  </WithData>
);
